var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWarningToastIcon = function SvgWarningToastIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.838,
    cy: 12.276,
    rx: 3.946,
    ry: 7.892,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.156 21.046a1.138 1.138 0 0 1-.994-.585 1.283 1.283 0 0 1-.16-.57 1.05 1.05 0 0 1 .16-.6L10.977.586a1.15 1.15 0 0 1 .453-.439A1.21 1.21 0 0 1 12 0c.195 0 .385.049.57.146.185.098.336.244.453.439l10.815 18.707c.117.195.17.394.16.599-.009.205-.063.395-.16.57a1.138 1.138 0 0 1-.994.585H1.156ZM12 17.538c.331 0 .609-.112.833-.336.224-.224.336-.502.336-.833 0-.331-.112-.61-.336-.833A1.131 1.131 0 0 0 12 15.2c-.331 0-.609.112-.833.336a1.132 1.132 0 0 0-.336.833c0 .331.112.609.336.833.224.224.502.336.833.336Zm0-3.508c.331 0 .609-.112.833-.336.224-.224.336-.502.336-.833V9.354c0-.332-.112-.61-.336-.833A1.131 1.131 0 0 0 12 8.184c-.331 0-.609.112-.833.337a1.132 1.132 0 0 0-.336.833v3.507c0 .331.112.61.336.833.224.224.502.336.833.336Z",
    fill: "#ED9F23"
  })));
};
export default SvgWarningToastIcon;